<p-messages
  class="m-messages"
  [class.m-messages-full-screen]="fullScreen"
  [class.m-messages-small]="variant === 'small'"
  [styleClass]="styleClass"
  [ngStyle]="materialIconStyle"
  [value]="messages"
  [closable]="closable"
  [escape]="escape"
  (valueChange)="handleClose($event)">
  <!-- Let consumer inject whatever they want -->
  <ng-content></ng-content>
</p-messages>
